import React, { useContext } from 'react';

import PerPointManagement from '../components/PerPointManagement';
import PerOrderManagement from '../components/PerOrderManagement';

import { PlaceStoreContext } from '../reducers/Place/PlaceContext';

const LivePage = () => {
  const [placeState] = useContext(PlaceStoreContext);
  const { orders, delivery } = placeState?.place?.features || {};

  if (orders?.active || delivery?.active) {
    return <PerPointManagement />;
  }

  return <PerOrderManagement />;
};

export default LivePage;
